export default __webpack_public_path__ + "static/media/indeterminate.89d70c2c.svg";